// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n._2rkoglpi{border-radius:var(--ds-border-radius,4px)}._1bsbnklw{width:20pc}\n._4t3i11ux{height:140px}\n._ca0q1b66{padding-top:var(--ds-space-050,4px)}\n._n3td1b66{padding-bottom:var(--ds-space-050,4px)}", ""]);
// Exports
module.exports = exports;
